import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import * as fromActions from './search-customers.actions';
import { ICustomer } from '@signal/asp-data-commons';

export interface SearchCustomersState extends EntityState<ICustomer> {
    customerSelectedId: string | null,
    pendingSearchInput: fromActions.PendingSearchInput | null,
    loading: boolean,
    loaded: boolean,
    error: string
}

export const adapter: EntityAdapter<ICustomer> = createEntityAdapter<ICustomer>(
    { selectId: (customer: ICustomer) => customer?.customerId?.toString() || ''}
);

export const initialState: SearchCustomersState = adapter.getInitialState({
    customerSelectedId: null,
    pendingSearchInput: null,
    loading: false,
    loaded: false,
    error: ''
});

export function searchCustomersReducer(
    state: SearchCustomersState = initialState,
    action: fromActions.SearchCustomersActions): SearchCustomersState{
        switch(action.type){
            case fromActions.SearchCustomersActionTypes.CLEAR_CUSTOMER_SELECTION: {
                return {
                    entities : {},
                    ids: [],
                    customerSelectedId: null,
                    pendingSearchInput: state.pendingSearchInput,
                    loading: false,
                    loaded: true,
                    error: ''
                };
            }
            case fromActions.SearchCustomersActionTypes.SEARCH_CUSTOMERS: {
                return {
                    ...adapter.removeAll(state),
                    customerSelectedId: null,
                    pendingSearchInput: state.pendingSearchInput,
                    loading: true,
                    loaded: false,
                    error: ''
                };
            }
            case fromActions.SearchCustomersActionTypes.SEARCH_CUSTOMERS_SUCCESS: {
                return {
                    ...adapter.setAll(action instanceof fromActions.SearchCustomersSuccess ? action.payload.customers : [], state),
                    customerSelectedId: null,
                    pendingSearchInput: state.pendingSearchInput,
                    loading: false,
                    loaded: true,
                    error: ''
                };
            }
            case fromActions.SearchCustomersActionTypes.SEARCH_CUSTOMERS_FAILURE: {
                return {
                    ...state,
                    loading: false,
                    loaded: true,
                    error: action instanceof fromActions.SearchCustomersFailure ? action.payload.error : ''
                };
            }
            case fromActions.SearchCustomersActionTypes.LOAD_CUSTOMER: {
                return {
                    ...state,
                    customerSelectedId: action instanceof fromActions.LoadCustomer ? action.payload.customerId : null,
                    loading: true,
                    loaded: false,
                    error: ''
                };
            }
            case fromActions.SearchCustomersActionTypes.DIRECT_LOAD_CUSTOMER: {
                const payload = action instanceof fromActions.DirectLoadCustomer ? action.payload : null;
                return {
                    ...adapter.setAll(payload.customers, state),
                    customerSelectedId: payload.customers?.find(x=> x.customerId===payload.customerId)?.customerId?.toString(),
                    loading: false,
                    loaded: true,
                    error: ''
                };
            }
            case fromActions.SearchCustomersActionTypes.LOAD_CUSTOMER_SUCCESS: {
                const payload = action instanceof fromActions.LoadCustomerSuccess ? action.payload : null;
                return {
                    ...adapter.setOne(payload.customer, state),
                    loading: false,
                    loaded: true
                };
            }
            case fromActions.SearchCustomersActionTypes.LOAD_CUSTOMER_FAILURE: {
                return {
                    ...state,
                    customerSelectedId: null,
                    loading: false,
                    loaded: false,
                    error: action instanceof fromActions.LoadCustomerFailure ? action.payload.error : null
                };
            }
            case fromActions.SearchCustomersActionTypes.SET_PENDING_SEARCH_INPUT: {
                return {
                    ...state,
                    pendingSearchInput: action instanceof fromActions.SetPendingSearchInput ? action.payload.pendingSearchInput : null
                };
            }
            case fromActions.SearchCustomersActionTypes.CLEAR_PENDING_SEARCH_INPUT: {
                return {
                    ...state,
                    pendingSearchInput: null
                };
            }
            default:
                return state;
        }

}